import { EditIcon } from '@chakra-ui/icons'
import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { getHasPrimaryCoverage, getHasSecondaryCoverage } from '@hb/shared'
import { ToggleButton, useFormWizard, useResizeObserver } from '@hb/shared-frontend'
import { useCallback, useMemo, useRef } from 'react'
import { useInsuranceInfoStage } from './context'

export const PlanIsMedicaid = ({
  label,
  isComplete,
}: {
  label: 'primary' | 'secondary'
  isComplete: boolean
}) => {
  const { insuranceInfoData, onUpdate, primaryCoverage, secondaryCoverage } =
    useInsuranceInfoStage()

  const { readOnly } = useFormWizard()
  const status = label === 'primary' ? primaryCoverage : secondaryCoverage
  const { complete, onEdit } = status

  const isMedicaidValue = useMemo(
    () =>
      label === 'primary'
        ? insuranceInfoData.primaryCoverage?.isMedicaid
        : insuranceInfoData.secondaryCoverage?.isMedicaid,
    [insuranceInfoData, label],
  )
  const valueIsSet = useMemo(
    () => isMedicaidValue !== null && isMedicaidValue !== undefined,
    [isMedicaidValue],
  )
  const isMedicaidActive = useMemo(
    // () => !!insuranceInfoData.option && canHaveSecondaryOptions.includes(insuranceInfoData.option),
    () => {
      if (insuranceInfoData.option === 'one-plan') return false
      if (insuranceInfoData.option === 'medicaid') return false
      return label === 'primary'
        ? getHasPrimaryCoverage(insuranceInfoData)
        : getHasSecondaryCoverage(insuranceInfoData)
    },
    [insuranceInfoData, label],
  )

  const handleEditClick = useCallback(() => {
    if (complete) onEdit()
    else
      onUpdate(
        label === 'primary'
          ? {
              primaryCoverage: undefined,
            }
          : {
              secondaryCoverage: undefined,
            },
      )
  }, [onUpdate, complete, onEdit, label])

  const handleSelect = useCallback(
    (value: boolean) => {
      if (value === null) return handleEditClick()
      onUpdate(
        label === 'primary'
          ? {
              primaryCoverage: {
                ...insuranceInfoData.primaryCoverage,
                isMedicaid: value,
              },
            }
          : {
              secondaryCoverage: {
                ...insuranceInfoData.secondaryCoverage,
                isMedicaid: value,
              },
            },
      )
    },
    [onUpdate, label, insuranceInfoData, handleEditClick],
  )

  const ref = useRef<HTMLDivElement>(null)
  const { width } = useResizeObserver(ref, 'content')
  // const buttonWidth = useMemo(() => {
  //   const baseWidth = width / 2 - 5
  //   if (!valueIsSet) return baseWidth
  //   return baseWidth - 24
  // }, [width, valueIsSet])

  // const showButton = useMemo(
  //   () => !complete && valueIsSet && !submittedOn,
  //   [complete, valueIsSet, submittedOn],
  // )
  const nonMedicaidWidth = useMemo(() => {
    if (!valueIsSet) return width / 2 - 5
    return !isMedicaidValue ? width : 0 // - (showButton ? 48 : 0) : 0
  }, [width, valueIsSet, isMedicaidValue])

  const medicaidWidth = useMemo(() => {
    if (!valueIsSet) return width / 2 - 5
    return isMedicaidValue ? width : 0 // - (showButton ? 48 : 0) : 0
  }, [width, valueIsSet, isMedicaidValue])

  return (
    <Collapse style={{ width: '100%' }} in={isMedicaidActive}>
      <Flex ref={ref} py={1} w="100%" flexFlow="column" gap={1}>
        <Collapse in={!isComplete} style={{ width: '100%' }}>
          <Text fontSize="lg">Is your {label} plan Medicaid?</Text>
        </Collapse>
        <Flex
          pointerEvents={readOnly ? 'none' : 'auto'}
          position="relative"
          justifyContent="space-between"
          align="center">
          <Box
            opacity={nonMedicaidWidth ? 1 : 0}
            width={`${nonMedicaidWidth}px`}
            transition="all 0.3s ease-in-out">
            <ToggleButton
              onClick={e => {
                e.stopPropagation()
                if (valueIsSet) handleEditClick()
                else handleSelect(false)
              }}
              minW={0}
              width="100%"
              transition="all 0.3s ease-in-out"
              isActive={isMedicaidValue === false}>
              Non-Medicaid
            </ToggleButton>
          </Box>
          <Box
            opacity={medicaidWidth ? 1 : 0}
            width={`${medicaidWidth}px`}
            transition="all 0.3s ease-in-out">
            <ToggleButton
              onClick={e => {
                e.stopPropagation()
                if (valueIsSet) handleEditClick()
                else handleSelect(true)
              }}
              transition="all 0.3s ease-in-out"
              minW={0}
              width="100%"
              isActive={isMedicaidValue === true}>
              Medicaid
            </ToggleButton>
          </Box>
          <EditIcon
            position="absolute"
            right={4}
            color="white"
            pointerEvents="none"
            bg="transparent"
            filter="drop-shadow(0 0 2px rgba(0, 0, 0, 0.5))"
            opacity={valueIsSet && !readOnly ? 1 : 0}
            transition="all 0.3s ease-in-out"
          />
          {/* <Box
            transition="all 0.3s ease-in-out"
            opacity={showButton ? 1 : 0}
            pointerEvents={showButton ? 'auto' : 'none'}
            width={`${showButton ? 40 : 0}px`}>
            <IconButton
              borderRadius="full"
              onClick={handleEditClick}
              icon={<EditIcon />}
              aria-label="Edit"
            />
          </Box> */}
        </Flex>
      </Flex>
    </Collapse>
  )
}

// export const PrimaryIsMedicaid = ({ isComplete }: { isComplete: boolean }) => (
//   <PlanIsMedicaid label="primary" isComplete={isComplete} />
// )

// export const SecondaryIsMedicaid = ({ isComplete }: { isComplete: boolean }) => (
//   <PlanIsMedicaid label="secondary" isComplete={isComplete} />
// )
